import React, { useEffect, useState } from "react"
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
} from "reactstrap"
import FullCalendar from "@fullcalendar/react"
import dayGridPlugin from "@fullcalendar/daygrid"
import interactionPlugin, { Draggable } from "@fullcalendar/interaction"
import BootstrapTheme from "@fullcalendar/bootstrap"
import secureLocalStorage from "react-secure-storage"
import {
    fetchNodeData,
    FetchNodePostData,
} from "utils/common-fetchData"
import moment from "moment"
import Loader from "pages/Separate/Loader"
import {
    calculateTotalTime,
} from "utils/common-helpers"
import Swal from "sweetalert2"
import Breadcrumb from "components/Common/Breadcrumb"
import bug from "../../../../assets/images/flags/bug-icon.png"
import Suggestion from "../../../../assets/images/flags/sugg-icon.png"
import { useNavigate } from "react-router-dom"
import configure from "configure"
import { useSelector } from "react-redux"

const ShowTicketPlanning = () => {
    const [activities, setActivities] = useState([])
    const [filterActivities, setFilterActivities] = useState([])
    const [allActivities, setAllActivities] = useState([])
    const [allPlanned, setAllPlanned] = useState([])
    const [activityName, setActiviyName] = useState("")
    const [projectId, setProjectId] = useState([])
    const [service, setService] = useState([])
    const [isDragging, setIsDragging] = useState(false)
    const [searchValue, setSearchValue] = useState("")
    document.addEventListener("keydown", e => {
        if (e.key == "Escape") {
            if (modal) {
                setModal(false)
            }
        }
    })

    const [modal, setModal] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [eventsList, setEvents] = useState([])
    const [modalData, setModalData] = useState({})
    const [eventData, setEventData] = useState({})
    const [qty, setQty] = useState("")
    const [addModal, setAddModal] = useState(false)
    const [changeKey, setChangeKey] = useState(false)

    useEffect(() => {
        new Draggable(document.getElementById("external-events"), {
            itemSelector: ".external-event",
        })
    }, [])

    const handleEventClick = (arg, dragging) => {
        const event = arg.event
        const data = event?._def?.extendedProps
        setActiviyName(event?.title)
        setQty(data?.quantity)
        const dat = moment(event.start).format("YYYY-MM-DD")
        const htmlString = customDateHtml[dat]
        const timeMatch = htmlString ? htmlString.match(/(\d{2}:\d{2})/) : null
        const time = timeMatch ? timeMatch[0] : "00:00"
        if (dragging == false) {
            setIsEdit(true)
            toggle()
        }
    }

    const onDrag = event => {
        event.preventDefault()
    }


    const [customDateHtml, setCustomDateHtml] = useState([])
    const [isLoading, setLoading] = useState(false)
    const token = secureLocalStorage.getItem("auth_id")
    const [isShow, setIsShow] = useState(false)
    const toggleLoading = load => {
        setLoading(load)
    }

    const onGetActivities = async () => {
        const res = await fetchNodeData(
            toggleLoading,
            `earthTicketsPlanning`,
            token
        )
        if (res?.status === 200) {
            const planned = res?.data?.planned_tickets || []
            const unplanned = res?.data?.unplanned_tickets || []

            setAllActivities(unplanned)
            setActivities(unplanned)
            setFilterActivities(unplanned)

            const plannedEvents = planned.map(obj => ({
                title: obj.subject,
                start: moment(obj.date).format("YYYY-MM-DD"), // use `date` field from API
                id: obj.id,
                ticket_id: obj.ticket_id,
                est_time: obj.estimated_time,
                description: obj.description,
                project_id: obj.project_id,
                added_by: obj.added_by,
                className: obj?.status == 5 || obj?.status == 4 ? "bg-success text-white" : obj?.type == 0 ? "bg-seo text-white" : "bg-smm text-white", // optional class for styling
                ...obj
            }))

            setEvents(plannedEvents)
            setAllPlanned(plannedEvents)
        }
    }

    useEffect(() => {
        onGetActivities()
    }, [])




    return (
        <React.Fragment>
            {isLoading && <Loader />}
            <div className="page-content mb-4">
                <Container fluid>
                    <Breadcrumb
                        title="Ticket Planning"
                        breadcrumbItem="Planned Earth ZAI Ticket"
                    />
                    <Row>
                        <Col lg={12} className="p-0">
                            <Card>
                                <CardBody>
                                    <div className="d-flex justify-content-between">
                                        <div className="mb-3 text-purple fs-5  fw-bold">Earth ZAI Tickets</div>
                                        <div className="d-flex gap-2">
                                            <label>My Tickets</label>
                                            <div className="form-switch form-switch-md ps-5">
                                                <input type="checkbox" className="form-check-input" id="customSwitchsizemd"
                                                    onChange={(e) => {
                                                        if (e.target.checked) {
                                                            setIsShow(!isShow)
                                                            setEvents(allPlanned?.filter((obj) => obj?.added_by == localStorage.getItem('auth_id')))
                                                        } else {
                                                            setEvents(allPlanned)
                                                            setIsShow(!isShow)
                                                        }
                                                    }} />
                                            </div>
                                        </div>
                                    </div>
                                    <Row className="pt-2 p-0">
                                        <Col lg={4} className="d-none">
                                            <Card>
                                                <div className="pt-0">
                                                    <div
                                                        id="external-events"
                                                        className="mt-0"
                                                        style={{
                                                            height: "860px",
                                                            overflowY: "auto",
                                                            scrollbarWidth: "thin",
                                                            scrollbarColor: "#8796ce #f0f0f0",
                                                        }}
                                                    >
                                                        <div className="search-box mb-3 me-2 ms-2">
                                                            <input
                                                                id="search-bar-0"
                                                                type="text"
                                                                className="s form-control rounded "
                                                                placeholder=" Search Tickets  ..."
                                                                onChange={e => {
                                                                    setSearchValue(e.target.value)
                                                                    const searchValue =
                                                                        e.target.value.toLowerCase()
                                                                    const filteredActivities = filterActivities.filter(activity =>
                                                                        activity.subject?.toLowerCase().includes(searchValue.toLowerCase()) ||
                                                                        String(activity?.id).includes(searchValue)
                                                                    );
                                                                    setActivities(filteredActivities)
                                                                }}
                                                                value={searchValue}
                                                            />
                                                            <span className="">
                                                                <i className="bx bx-search-alt search-icon ms-2"></i>
                                                            </span>
                                                            <a className="">
                                                                <i
                                                                    className="bx  bx-x-circle search-icon ms-2 text-danger cursor-pointer"
                                                                    onClick={() => {
                                                                        setSearchValue("")
                                                                        setActivities(filterActivities)
                                                                    }}
                                                                    style={{ left: "90%" }}
                                                                ></i>
                                                            </a>
                                                        </div>
                                                        {activities &&
                                                            activities.map((category, i) => {
                                                                return (
                                                                    <div
                                                                        className="d-flex justify-space-between align-items-center"
                                                                        key={i}
                                                                    >
                                                                        <div
                                                                            className={` external-event fc-event text-white w-100 d-flex justify-space-between align-items-center`}
                                                                            id={category?.id}
                                                                            draggable
                                                                            onDrag={event =>
                                                                                onDrag(event, category)
                                                                            }
                                                                        >
                                                                            <span>
                                                                                {category?.id} - {' '}
                                                                                {category.subject}
                                                                            </span>
                                                                            <span>
                                                                                <img
                                                                                    src={
                                                                                        category?.type == 0
                                                                                            ? bug
                                                                                            : Suggestion
                                                                                    }
                                                                                    alt="No Img"
                                                                                    className=""
                                                                                    width={20}
                                                                                    height={20}
                                                                                />
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })}
                                                        {activities?.length == 0 ? (
                                                            <p className="text-center text-purple fw-bold mt-3">
                                                                🎉 All pending Tickets have been planned for
                                                                future! <br />
                                                            </p>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </Card>
                                        </Col>
                                        <Col lg={12} className="">
                                            <div className="show-date">
                                                <FullCalendar
                                                    key={isShow}
                                                    plugins={[
                                                        BootstrapTheme,
                                                        dayGridPlugin,
                                                        interactionPlugin,
                                                    ]}
                                                    slotDuration={"00:15:00"}
                                                    handleWindowResize={true}
                                                    themeSystem="bootstrap"
                                                    weekends={true}
                                                    headerToolbar={{
                                                        left: "prev,next today",
                                                        center: "title",
                                                        right: "dayGridMonth,dayGridWeek,dayGridDay",
                                                    }}
                                                    events={eventsList}
                                                    eventContent={arg => {
                                                        const { event } = arg
                                                        const id =
                                                            event.extendedProps?.ticket_id || event.id
                                                        return (
                                                            <div className="d-flex flex-column justify-content-start align-items-start">
                                                                <div
                                                                    className="text-start"
                                                                    style={{
                                                                        wordWrap: "break-word",
                                                                        wordBreak: "break-word",
                                                                        whiteSpace: "normal",
                                                                        maxWidth: "100%",
                                                                    }}
                                                                >
                                                                    <span>#{id}</span> - {event.title}{" "}

                                                                    <div className="font-size-11 text-purple fw-bold">Live Date : {moment(event?.extendedProps?.live_date).format('DD MMM')}</div>
                                                                </div>
                                                            </div>
                                                        )
                                                    }}
                                                    dayCellContent={(cell) => {
                                                        const { date } = cell;

                                                        return (
                                                            <div className="fc-day-cell-content w-100 justify-space-between align-items-center" style={{ flexDirection: "initial" }}>
                                                                <div className="fc-day-number">{date.getDate()}</div>
                                                            </div>
                                                        );
                                                    }}
                                                    editable={false}
                                                    droppable={false}
                                                    selectable={true}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default ShowTicketPlanning
